// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608212034/js/" + chunkId + "." + {"44":"3ca5a22b","225":"3d19782b","481":"67321967","486":"46d0568b","770":"47ef5c44"}[chunkId] + ".0.9782511061693473.chunk.js";
};